import { fetch as fetchRaw } from '@lib/fetch';
import { getDefinedUrlSearchParams } from '@lib/util';
import { companies } from '../services';

const fetch = (url, ...args) => fetchRaw([companies.url, url], ...args);

/**
 *
 * @param {('ABOUT'|'OPERATIONAL_METRICS'|'OTHER_IDS')} templateId
 * @param {string} forCompanyId
 * @returns
 */
export const getCompanyProfileById = (templateId, forCompanyId) => {
  return fetch(`/v1/profiles/${templateId}/company/${forCompanyId}`, {
    method: 'GET',
  });
};

export function getCompaniesList(queryParams) {
  return fetch(`/v1/companies?${getDefinedUrlSearchParams(queryParams)}`, {
    method: 'GET',
  });
}

export const adminGetCompaniesList = queryParams => {
  return fetch(
    `/v1/admin/companies/list?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
};

export const companyCreate = body => {
  return fetch('/v1/companies', { method: 'POST', body: JSON.stringify(body) });
};

export function companyLink(body) {
  return fetch('/v1/companies/link', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function companyUnLink(body) {
  return fetch('/v1/companies/unlink', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function companyBulkUnLink(body) {
  return fetch('/v1/companies/bulk-unlink', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function shareAsset(body) {
  return fetch('/v1/assets/share', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getAssetAccessControl(assetId) {
  return fetch(`/v1/assets/access-control/${assetId}`, {
    method: 'GET',
  });
}

export function getGlobalCompanyProfiles(profileType, queryParams) {
  return fetch(
    `/v1/profiles/${profileType}/companies?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export const getImpactAreasBySectionId = sectionId => {
  return fetch(`/v1/impact-areas/hierarchy/${sectionId}`, { method: 'GET' });
};

export const listDataPointsAnswers = (companyId, queryParams) => {
  return fetch(
    `/v1/data-points-answers/companies/${companyId}?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
};

export const companiesGetAll = queryParams => {
  return fetch(
    `/v1/admin/companies/list?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
};

export const removedCompaniesGetAll = queryParams => {
  return fetch(
    `/v1/admin/companies-removed/list?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
};

export const listRemovedCompanyNetworkUnscoped = (companyId, queryParams) => {
  return fetch(
    `/v1/admin/companies-removed/${companyId}/list-network?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
};

export const listCompanyNetworkUnscoped = (companyId, queryParams) => {
  return fetch(
    `/v1/admin/companies/${companyId}/list-network?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
};

export const companyGetByAdmin = id => {
  return fetch(`/v1/admin/companies/${id}`, {
    method: 'GET',
  });
};

export const removedCompanyGetByAdmin = id => {
  return fetch(`/v1/admin/companies-removed/${id}`, {
    method: 'GET',
  });
};

export const getAdminCompanyProfileById = (templateId, forCompanyId) => {
  return fetch(`/v1/admin/profiles/${templateId}/companies/${forCompanyId}`, {
    method: 'GET',
  });
};

export const markDemoCompanyByAdmin = body => {
  return fetch('/v1/admin/companies/mark-demo', {
    method: 'PUT',
    body: JSON.stringify(body),
  });
};

export const unmarkDemoCompanyByAdmin = id => {
  return fetch(`/v1/admin/companies/${id}/remove-demo`, {
    method: 'DELETE',
  });
};

export const markCompaniesClient = body => {
  return fetch('/v1/admin/clients', {
    method: 'POST',
    body: JSON.stringify(body),
  });
};

export const removeCompaniesClient = body => {
  return fetch('/v1/admin/clients', {
    method: 'DELETE',
    body: JSON.stringify(body),
  });
};

export const companyRemoveByAdmin = id => {
  return fetch(`/v1/admin/companies/${id}`, {
    method: 'DELETE',
  });
};

export const companyRestoreByAdmin = id => {
  return fetch(`/v1/admin/companies-removed/${id}`, {
    method: 'DELETE',
  });
};

export { getCompaniesListVectorSearch } from './companies/index';
